import _ from 'lodash'
import buildQuery from 'odata-query'
import { getUserFactoryId } from '../../..'
import api from '../../services/api'


export const fetchByOdata = async (id) => {
    return api.get(`externalmaterial/${id}`)
}